import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                /* Colors */
                primary: '#E97C38',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                background: '#F0EFED',
                surface: '#FFFFFF',
                'form-control-color': '#FFFFFF',
                /* Fonts */
                'on-primary': '#FFFFFF',
                'on-surface': '#000000'
            }
        }
    },
    icons: {
        iconfont: 'fa'
    }
});
